import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold mb-4" }, "Neuen Account verknüpfen", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Zugangsdaten des zu verknüpfenden Accounts ")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-lg-12" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "Benutzername", -1)
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "Passwort", -1)
const _hoisted_15 = { class: "col-md-9" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["type"]
const _hoisted_18 = { class: "input-group-append" }
const _hoisted_19 = { class: "card-footer d-flex justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "2",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username.value) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.username.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        type: _ctx.password.protected?'password':'text',
                        tabindex: "2",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password.value) = $event))
                      }, null, 8, _hoisted_17), [
                        [_vModelDynamic, _ctx.password.value]
                      ]),
                      _createElementVNode("span", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.password.protected=!_ctx.password.protected))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fal", _ctx.password.protected?'fa-eye':'fa-eye-slash'])
                          }, null, 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("a", {
              href: "",
              class: "text-muted",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backToAccounts && _ctx.backToAccounts(...args)), ["prevent"]))
            }, "Zurück zu Accounts"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.linkAccount && _ctx.linkAccount(...args)))
            }, "Jetzt verknüpfen")
          ])
        ])
      ])
    ])
  ]))
}